import { CalendarDate } from '@mathflat/shared/@modules/(dto)/CalendarDate'
import { subDays } from 'date-fns'

/** 달마다 일수가 달라 화면별로 각자 계산하면 하루씩 어긋나므로 오늘 포함 30일로 고정 */
export const DEFAULT_STUDY_PERIOD_DAYS = 30

export function getDefaultStudyPeriodRange(end: CalendarDate = new CalendarDate()): {
  start: CalendarDate
  end: CalendarDate
} {
  return {
    start: new CalendarDate(subDays(end.dateObj, DEFAULT_STUDY_PERIOD_DAYS - 1)),
    end,
  }
}
